import { ProcessCalculation } from '../../domain/process-calculation';
import { mapper } from '../../tools/mapping/mapper';
import { ProcessCalculationEntity } from '../entity';
import type { AppDB } from '../db';

export class ProcessCalculationRepository {
    constructor(private readonly database: AppDB) {}


    async getProcessCalculationById(id: number) {
        return await this.database.processCalculations.where('Id').equals(id).first(async pce => {
            const pc = mapper.map(pce, ProcessCalculationEntity, ProcessCalculation);
            return pc;
        });
    }

    async attachProcessCalculation(processTechnique: ProcessCalculation, processId: number) {
        let processCalculationId: number;
        const pte = mapper.map(processTechnique, ProcessCalculation, ProcessCalculationEntity);

        processCalculationId = await this.database.processCalculations.add(pte);
        await this.database.process.update(processId, {
            ProcessCalculationId: processCalculationId
        });

        return processCalculationId;
    }
}
